
import { useTranslation } from 'react-i18next';

export default function LendingSafetySection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gradient-to-br from-gray-900 to-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 bg-green-600/20 border border-green-500 rounded-full px-6 py-3 mb-6">
            <i className="ri-shield-check-line text-3xl text-green-400"></i>
            <h2 className="text-2xl md:text-3xl font-bold text-white">
              {t('lending.safety.title')}
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-gray-800 rounded-xl p-8 border border-gray-700 text-center">
            <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-money-dollar-circle-line text-4xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-yellow-400 mb-4">
              {t('lending.safety.zero1.title')}
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              {t('lending.safety.zero1.desc')}
            </p>
            <div className="text-3xl font-bold text-green-400">
              {t('lending.safety.zero1.badge')}
            </div>
          </div>

          <div className="bg-gray-800 rounded-xl p-8 border border-gray-700 text-center">
            <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-brain-line text-4xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-yellow-400 mb-4">
              {t('lending.safety.zero2.title')}
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              {t('lending.safety.zero2.desc')}
            </p>
            <div className="text-3xl font-bold text-blue-400">
              {t('lending.safety.zero2.badge')}
            </div>
          </div>

          <div className="bg-gray-800 rounded-xl p-8 border border-gray-700 text-center">
            <div className="w-20 h-20 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-line-chart-line text-4xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-yellow-400 mb-4">
              {t('lending.safety.zero3.title')}
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              {t('lending.safety.zero3.desc')}
            </p>
            <div className="text-3xl font-bold text-purple-400">
              {t('lending.safety.zero3.badge')}
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-green-900/40 to-teal-900/40 border-2 border-green-500 rounded-2xl p-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-green-500/10 to-teal-500/10"></div>
          <div className="relative z-10">
            <div className="inline-flex items-center justify-center w-40 h-40 bg-gradient-to-br from-green-500 to-teal-500 rounded-full mb-6 shadow-2xl shadow-green-500/50 animate-pulse">
              <span className="text-8xl font-black text-white">0</span>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {t('lending.safety.zeroRisk.title')}
            </h3>
            <p className="text-gray-200 text-xl max-w-2xl mx-auto">
              {t('lending.safety.zeroRisk.desc')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
